import styled from '@app/styled';

export const Wrapper = styled.div`
    position: relative;
    width: 100%;
`;

export const IconWrapper = styled.div`
    position: absolute;
    left: 18px;
    top: 0;
    height: 100%;
    display: flex;
    align-items: center;
`;
